<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <!--<div class="md-layout-item md-size-50 no-padding">-->
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>account_tree</md-icon>코드 그룹
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ pagination.total }} 건의 검색결과가 있습니다.</div>
              <div>
                <md-button class="md-info md-sm" @click="addCode('GRP')">
                  <md-icon>create_new_folder</md-icon>신규등록
                </md-button>&nbsp;
                <md-button class="md-info md-sm" @click="editCode('GRP')">
                  <md-icon>create_new_folder</md-icon>수정
                </md-button>&nbsp;
                <md-button class="md-default md-sm" @click="deleteCode('GRP')" v-if="this.authGrp == 5 || this.authGrp == 3">
                  <md-icon>create_new_folder</md-icon>삭제
                </md-button>
              </div>
            </div>
            <div>
              <grid ref="codeGrpGrid"
                    :data="gridProps.data"
                    :columns="gridProps.columns"
                    :options="gridProps.options"
                    :theme="gridProps.theme"
                    :rowHeaders="gridProps.rowHeaders"
                    :columnOptions="gridProps.columnOptions"
                    :language="gridProps.lang"
                    @click="gridRowClick($event,'GRP')"
                    @dblclick="onGrpDblClickData"
                    @response="response"
              ></grid>
            </div>

          </md-card-content>
        </md-card>
      <!--</div>-->
      <!--<div class="md-layout-item md-size-20 no-padding">-->
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>filter_2</md-icon>대분류 코드
              <span v-if="selectedGrpRow && selectedGrpRow.codeGrpId"> - {{selectedGrpRow.codeNm}}({{selectedGrpRow.codeGrpId}})</span>
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ lPagination.total }} 건의 검색결과가 있습니다.</div>
              <div>
                <md-button class="md-info md-sm" @click="addCode('L')">
                  <md-icon>create_new_folder</md-icon>신규등록
                </md-button>&nbsp;
                <md-button class="md-info md-sm" @click="editCode('L')">
                  <md-icon>create_new_folder</md-icon>수정
                </md-button>&nbsp;
                <md-button class="md-default md-sm" @click="deleteCode('L')" v-if="this.authGrp == 5 || this.authGrp == 3">
                  <md-icon>create_new_folder</md-icon>삭제
                </md-button>
              </div>
            </div>
            <div>
              <grid ref="codeLGrid"
                    :data="gridLProps.data"
                    :columns="gridLProps.columns"
                    :options="gridLProps.options"
                    :theme="gridLProps.theme"
                    :rowHeaders="gridLProps.rowHeaders"
                    :columnOptions="gridLProps.columnOptions"
                    :language="gridLProps.lang"
                    @click="gridRowClick($event,'L')"
                    @dblclick="onLDblClickData"
                    @response="response"
              ></grid>
            </div>

          </md-card-content>
        </md-card>
<!--      </div>-->
<!--      <div class="md-layout-item md-size-20 no-padding">-->
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>filter_3</md-icon>중분류 코드
              <span v-if="selectedLRow && selectedLRow.codeCd"> - {{selectedLRow.codeNm}}({{selectedLRow.codeCd}})</span>
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ mPagination.total }} 건의 검색결과가 있습니다.</div>
              <div>
                <md-button class="md-info md-sm" @click="addCode('M')">
                  <md-icon>create_new_folder</md-icon>신규등록
                </md-button>&nbsp;
                <md-button class="md-info md-sm" @click="editCode('M')">
                  <md-icon>create_new_folder</md-icon>수정
                </md-button>&nbsp;
                <md-button class="md-default md-sm" @click="deleteCode('M')" v-if="this.authGrp == 5 || this.authGrp == 3">
                  <md-icon>create_new_folder</md-icon>삭제
                </md-button>
              </div>
            </div>
            <div>
              <grid ref="codeMGrid"
                    :data="gridMProps.data"
                    :columns="gridMProps.columns"
                    :options="gridMProps.options"
                    :theme="gridMProps.theme"
                    :rowHeaders="gridMProps.rowHeaders"
                    :columnOptions="gridMProps.columnOptions"
                    :language="gridMProps.lang"
                    @click="gridRowClick($event,'M')"
                    @dblclick="onMDblClickData"
                    @response="response"
              ></grid>
            </div>
          </md-card-content>
        </md-card>
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>filter_3</md-icon>소분류 코드
            <span v-if="selectedMRow && selectedMRow.codeCd"> - {{selectedMRow.codeNm}}({{selectedMRow.codeCd}})</span>
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ sPagination.total }} 건의 검색결과가 있습니다.</div>
            <div>
              <md-button class="md-info md-sm" @click="addCode('S')">
                <md-icon>create_new_folder</md-icon>신규등록
              </md-button>&nbsp;
              <md-button class="md-info md-sm" @click="editCode('S')">
                <md-icon>create_new_folder</md-icon>수정
              </md-button>&nbsp;
              <md-button class="md-default md-sm" @click="deleteCode('S')" v-if="this.authGrp == 5 || this.authGrp == 3">
                <md-icon>create_new_folder</md-icon>삭제
              </md-button>
            </div>
          </div>
          <div>
            <grid ref="codeSGrid"
                  :data="gridSProps.data"
                  :columns="gridSProps.columns"
                  :options="gridSProps.options"
                  :theme="gridSProps.theme"
                  :rowHeaders="gridSProps.rowHeaders"
                  :columnOptions="gridSProps.columnOptions"
                  :language="gridSProps.lang"
                  @click="gridRowClick($event,'S')"
                  @response="response"
            ></grid>
          </div>
        </md-card-content>
      </md-card>
<!--      </div>-->
    </div>

    <!-- --------------------------- Modal Popup --------------------------------------->
    <div>
      <!--코드 신규등록 팝업 -->
      <add-code-pop-comp :is-show.sync="isShowAddCodeModal" :is-edit.sync="isEdit" :add-code-type.sync="addCodeType" :add-code-grp-row.sync="selectedGrpRow" :add-code-l-row.sync="selectedLRow" :add-code-m-row.sync="selectedMRow" @returnResult="callbackAddCode" ref="addModal"></add-code-pop-comp>
    </div>
    <!-- --------------------------- Modal Popup --------------------------------------->
  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import Swal from "sweetalert2";
import AddCodePopComp from "@/pages/Operation/Components/AddCodePopComp"

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import session from "@/kuaa/kuaa-sessions";

export default {
  components: {
    AddCodePopComp,
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
  },

  data(){
    return{
      authGrp : session.get('group'),
      isEdit : false,
      selectedGrpRow: null,
      selectedLRow: null,
      selectedMRow: null,

      checkedGrpRow: null,
      checkedLRow: null,
      checkedMRow: null,
      checkedSRow: null,

      addCodeType: null,

      isShowAddCodeModal: false,

      pagination: {
        page: 1,
        perPage: 10,
        total: 0
      },
      lPagination: {
        page: 1,
        perPage: 10,
        total: 0
      },
      mPagination: {
        page: 1,
        perPage: 10,
        total: 0
      },
      sPagination: {
        page: 1,
        perPage: 10,
        total: 0
      }

    };
  },
  methods: {
    initGrid() {
      let cmm_cols = [
        {header: '정렬순서', name: 'codeOrdr', align:'center'},
        {header: '사용여부', name: 'useYn', align:'center'},
        {header: '메타1', name: 'etcMeta1', align:'left'},
        {header: '메타2', name: 'etcMeta2', align:'left'},
        {header: '메타3', name: 'etcMeta3', align:'left'},
        {header: '메타4', name: 'etcMeta4', align:'left'},
        {header: '메타5', name: 'etcMeta5', align:'left'}
      ];

      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_CODE_GRP_LIST, true, this.pagination);
      this.gridProps['el'] = this.$refs.codeGrpGrid;
      this.gridProps['columns']= [
          {header: null, name: null, align : 'center', width:50,
            formatter(value) {
              return '<input type="radio" id="radio-GRP-' + value.row.codeGrpId + '" name="selectedGrpRow">';
            }
          },
          {header: '코드그룹ID', name: 'codeGrpId', align:'left'},
          {header: '코드그룹명', name: 'codeNm', align:'left', width:"auto"},
          {header: '코드그룹상세', name: 'codeDesc', align:'left', width:"auto"}
      ].concat(cmm_cols);
      this.gridProps['options'].bodyHeight = 280;

      this.gridLProps = kuaaFnc.setGridInit(URL_CONST.GET_CODE_L_LIST, false, this.lPagination);
      this.gridLProps['el'] = this.$refs.codeLGrid;
      this.gridLProps['columns']= [
        {header: null, name: null, align : 'center', width:50,
          formatter(value) {
            return '<input type="radio" id="radio-L-' + value.row.codeCd + '" name="selectedLRow">';
          }
        },
        {header: '코드그룹ID', name: 'codeGrpId', align:'left'},
        {header: '대분류코드', name: 'codeCd', align:'center'},
        {header: '대분류코드명', name: 'codeNm', align:'left', width:"auto"},
        {header: '대분류코드상세', name: 'codeDesc', align:'left', width:"auto"}
      ].concat(cmm_cols);
      this.gridLProps['options'].bodyHeight = 150;

      this.gridMProps = kuaaFnc.setGridInit(URL_CONST.GET_CODE_M_LIST, false, this.mPagination);
      this.gridMProps['el'] = this.$refs.codeMGrid;
      this.gridMProps['columns']= [
        {header: null, name: null, align : 'center', width:50,
          formatter(value) {
            return '<input type="radio" id="radio-M-' + value.row.codeCd + '" name="selectedMRow">';
          }
        },
        {header: '코드그룹ID', name: 'codeGrpId', align:'left'},
        {header: '대분류코드', name: 'lCodeCd', align:'center'},
        {header: '중분류코드', name: 'codeCd', align:'center'},
        {header: '중분류코드명', name: 'codeNm', align:'left', width:"auto"},
        {header: '중분류코드상세', name: 'codeDesc', align:'left', width:"auto"}
      ].concat(cmm_cols);
      this.gridMProps['options'].bodyHeight = 150;

      this.gridSProps = kuaaFnc.setGridInit(URL_CONST.GET_CODE_S_LIST, false, this.sPagination);
      this.gridSProps['el'] = this.$refs.codeSGrid;
      this.gridSProps['columns']= [
        {header: null, name: null, align : 'center', width:50,
          formatter(value) {
            return '<input type="radio" id="radio-S-' + value.row.codeCd + '" name="selectedSRow">';
          }
        },
        {header: '코드그룹ID', name: 'codeGrpId', align:'left'},
        {header: '대분류코드', name: 'lCodeCd', align:'center'},
        {header: '중분류코드', name: 'mCodeCd', align:'center'},
        {header: '소분류코드', name: 'codeCd', align:'center'},
        {header: '소분류코드명', name: 'codeNm', align:'left', width:"auto"},
        {header: '소분류코드상세', name: 'codeDesc', align:'left', width:"auto"}
      ].concat(cmm_cols);
      this.gridSProps['options'].bodyHeight = 150;
    },

    response(e){
      let resUrl = e.xhr.responseURL;
      let res = JSON.parse(e.xhr.response);

      if(res.result){
        if(resUrl.endsWith(URL_CONST.GET_CODE_GRP_LIST)){
          this.pagination.total = res.data.pagination.totalCount;
          this.checkedGrpRow = null;
        } else if(resUrl.endsWith(URL_CONST.GET_CODE_L_LIST)) {
          this.lPagination.total = res.data.pagination.totalCount;
          this.checkedLRow = null;
        } else if(resUrl.endsWith(URL_CONST.GET_CODE_M_LIST)){
          this.mPagination.total = res.data.pagination.totalCount;
          this.checkedMRow = null;
        } else if(resUrl.endsWith(URL_CONST.GET_CODE_S_LIST) || resUrl.endsWith(URL_CONST.GET_CPN_LIST)){
          this.sPagination.total = res.data.pagination.totalCount;
          this.checkedSRow = null;
        }
      }else{
        kuaaFnc.showSwal("코드 관리", res.resultMessage);
      }
    },

    resetGrid(type){
      switch (type) {
        case 'GRP' :
          //this.$refs.codeGrpGrid.invoke("clear");
          this.checkedGrpRow = null;
          break;
        case 'L' :
          this.checkedLRow = null;
          //this.$refs.codeLGrid.invoke("clear");
          break;
        case 'M' :
          this.checkedMRow = null;
          //this.$refs.codeMGrid.invoke("clear");
          break;
        case 'S' :
          this.checkedSRow = null;
          //this.$refs.codeSGrid.invoke("clear");
          break;
      }
    },

    reLoadGrid(){
      switch (this.addCodeType) {
        case 'GRP' :
          this.$refs.codeGrpGrid.invoke("readData", this.$refs.codeGrpGrid.invoke("getPagination")._currentPage);
          break;
        case 'L' :
          this.$refs.codeLGrid.invoke("readData", this.$refs.codeLGrid.invoke("getPagination")._currentPage, {codeGrpId: this.selectedGrpRow.codeGrpId});
          break;
        case 'M' :
          this.$refs.codeMGrid.invoke("readData", this.$refs.codeMGrid.invoke("getPagination")._currentPage, {codeGrpId: this.selectedGrpRow.codeGrpId, lCodeCd: this.selectedLRow.lCodeCd});
          break;
        case 'S' :

          if(this.selectedGrpRow.codeGrpId == 'WORK_CD'){
            this.$refs.codeSGrid['data'].api.readData.url = URL_CONST.GET_CPN_LIST;
          }else{
            this.$refs.codeSGrid['data'].api.readData.url = URL_CONST.GET_CODE_S_LIST;
          }
          
          this.$refs.codeSGrid.invoke("readData", this.$refs.codeSGrid.invoke("getPagination")._currentPage, {codeGrpId: this.selectedGrpRow.codeGrpId, lCodeCd: this.selectedLRow.codeCd, mCodeCd: this.selectedMRow.codeCd});
          break;
      }
    },

    onGrpDblClickData(e) {
      if(e.instance.getRow(e.rowKey) != null) {
        let rowData = e.instance.getRow(e.rowKey);
        this.$refs.codeLGrid.invoke("readData", 1, {codeGrpId: rowData.codeGrpId});

        this.selectedGrpRow = rowData;

        // 중분류 초기화
        this.$refs.codeMGrid.invoke("clear");
        this.mPagination.total = 0;
        this.selectedLRow = null;

        // 소분류 초기화
        this.$refs.codeSGrid.invoke("clear");
        this.sPagination.total = 0;
        this.selectedMRow = null;
      }
    },

    onLDblClickData(e) {
      if(e.instance.getRow(e.rowKey) != null) {
        let rowData = e.instance.getRow(e.rowKey);
        this.$refs.codeMGrid.invoke("readData", 1, {codeGrpId: rowData.codeGrpId, lCodeCd: rowData.codeCd});

        this.selectedLRow = rowData;

        // 소분류 초기화
        this.$refs.codeSGrid.invoke("clear");
        this.sPagination.total = 0;
        this.selectedMRow = null;
      }
    },

    onMDblClickData(e) {
      if(e.instance.getRow(e.rowKey) != null) {
        let rowData = e.instance.getRow(e.rowKey);
        if(rowData.codeGrpId == 'WORK_CD'){
          this.$refs.codeSGrid['data'].api.readData.url = URL_CONST.GET_CPN_LIST;
        }else{
          this.$refs.codeSGrid['data'].api.readData.url = URL_CONST.GET_CODE_S_LIST;
        }
        this.$refs.codeSGrid.invoke("readData", 1, {codeGrpId: rowData.codeGrpId, lCodeCd: rowData.lCodeCd, mCodeCd: rowData.codeCd});

        this.selectedMRow = rowData;
      }
    },

    addCode(type){
      if (
        type === 'L' && !this.selectedGrpRow ||
        type === 'M' && !this.selectedLRow ||
        type === 'S' && !this.selectedMRow
      ) {
        kuaaFnc.showSwal("코드 관리", '부모 분류를 먼저 선택하세요');
        return false;
      }

      this.isEdit = false;

      this.addCodeType = type;

      // modal 띄우기
      this.isShowAddCodeModal = true;
    },

    callbackAddCode(result) {
      let _this = this;
      if (result === 'success') {
        kuaaFnc.showSwal("코드 관리", _this.isEdit ? '수정 되었습니다.' : '추가되었습니다.');
        this.reLoadGrid();
      }
    },

    gridRowClick(e,type){
      if(e.instance.getRow(e.rowKey) != null) {
        let obj = e.instance.getRow(e.rowKey);
        switch (type) {
          case 'GRP' :
            this.checkedGrpRow = obj;
            document.getElementById('radio-'+ type + '-' + obj.codeGrpId).checked = true;
            break;
          case 'L' :
            this.checkedLRow = obj;
            document.getElementById('radio-'+ type + '-' + obj.codeCd).checked = true;
            break;
          case 'M' :
            this.checkedMRow = obj;
            document.getElementById('radio-'+ type + '-' + obj.codeCd).checked = true;
            break;
          case 'S' :
            this.checkedSRow = obj;
            document.getElementById('radio-'+ type + '-' + obj.codeCd).checked = true;
            break;
        }
      }
    },

    editCode (type){
      let targetObj = null;
      switch (type) {
        case 'GRP' :
          targetObj = this.checkedGrpRow;
          break;
        case 'L' :
          targetObj = this.checkedLRow;
          break;
        case 'M' :
          targetObj = this.checkedMRow;
          break;
        case 'S' :
          targetObj = this.checkedSRow;
          break;
      }

      if (!targetObj) {
        kuaaFnc.showSwal("코드 관리", '대상을 선택 하세요');
        return false;
      }

      this.$refs.addModal.setData(targetObj,type);
      this.isEdit = true;
      this.addCodeType = type;
      // modal 띄우기
      this.isShowAddCodeModal = true;
    },

    deleteCode(type) {
      if (
        type === 'GRP' && !this.checkedGrpRow ||
        type === 'L' && !this.checkedLRow ||
        type === 'M' && !this.checkedMRow ||
        type === 'S' && !this.checkedSRow
      ) {
        kuaaFnc.showSwal("코드 관리", '대상 코드를 선택하세요');
        return false;
      }

      let options = {};
      let url = null;

      // 최상위 코드
      if (type === 'GRP') {
        url = URL_CONST.DELETE_CODE_GRP_LIST;
        options.codeGrpId = this.checkedGrpRow.codeGrpId;
      }
      // 대분류 코드
      else if (type === 'L') {
        url = URL_CONST.DELETE_CODE_L_LIST;
        options.codeGrpId = this.checkedLRow.codeGrpId;
        options.codeCd = this.checkedLRow.codeCd;
      }
      // 중분류 코드
      else if (type === 'M') {
        url = URL_CONST.DELETE_CODE_M_LIST;

        options.codeGrpId = this.checkedMRow.codeGrpId;
        options.lCodeCd = this.checkedMRow.lCodeCd;
        options.codeCd = this.checkedMRow.codeCd;
      }
      // 소분류 코드
      else if (type === 'S') {
        url = URL_CONST.DELETE_CODE_S_LIST;
        
        options.codeGrpId = this.checkedSRow.codeGrpId;
        options.lCodeCd = this.checkedSRow.lCodeCd;
        options.mCodeCd = this.checkedSRow.mCodeCd;
        options.codeCd = this.checkedSRow.codeCd;
      }

      this.addCodeType = type;

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "삭제 하시겠습니까?"
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          kuaaApi.sendServer(url, options, "post", response => {
            if(response.data.resultCode == 'MC000'){
              kuaaFnc.showSwal("코드 관리", `삭제 되었습니다.`);
              resetGrid(type);
              this.reLoadGrid();
            }else{
              kuaaFnc.showSwal("코드 관리", `삭제 실패 하였습니다.`);
            }
          });
        }
      });


    }


  }
}
</script>

<style>

</style>